import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NotificationProvider } from './components/Notifications';
// import { registerServiceWorker, requestNotificationPermission } from './serviceWorkerRegistration';
import { setupInstallPrompt } from './utils/pwaUtils';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NotificationProvider>
      <App />
    </NotificationProvider>
  </React.StrictMode>
);

// Register service worker for PWA support
// registerServiceWorker();

// Setup PWA install prompt handling
setupInstallPrompt();

// Request notification permission (optional)
// requestNotificationPermission();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
